/// <reference path="../../../app.definition.ts" />

import angular from 'angular';

export class PrivacyPopUpController {

  static $inject = ["PopUpService", "$uibModalInstance", "$uibModal"];

  constructor(
    PopUpService,
    $uibModalInstance, $uibModal
  ) {
    console.log('privacy controller called');
    var privacyPopUpVm = this;
    console.log('TEST privacy');
    privacyPopUpVm.proceedSignup = () => {

      $uibModalInstance.close();

    }

    privacyPopUpVm.closePopup = () => {

      $uibModalInstance.close();


    }

  }
}


angular.module('eCareVault.common.popUp')
  .controller('PrivacyPopUpController', PrivacyPopUpController);
